import { FileClock, List, PenLine } from "lucide-react";
import { useStoryPreferences } from "../i18n";
import type { WorkspaceView } from "./WorkspaceNav";

export type MobileView = "outline" | "write" | "changes";

type MobileNavProps = {
  activeView: MobileView;
  onChange: (view: MobileView) => void;
  onPropose?: () => void;
  canPropose?: boolean;
  proposing?: boolean;
  workspace?: WorkspaceView;
  onWorkspace?: (view: WorkspaceView) => void;
};

export function MobileNav({ activeView, onChange, onPropose, canPropose = false, proposing = false, workspace = "write", onWorkspace }: MobileNavProps) {
  const { t } = useStoryPreferences();
  return (
    <div className="mobile-command-area">
      <div className="mobile-continuity-row">
        {onWorkspace ? <select aria-label={t("workspaceLabel")} value={workspace} onChange={(event) => onWorkspace(event.target.value as WorkspaceView)}>{(["write", "world", "version", "context", "intelligence", "production", "collaboration"] as const).map((view) => <option key={view} value={view}>{t(view === "context" ? "contextAi" : view === "collaboration" ? "collaborationGame" : view)}</option>)}</select> : null}
        <button type="button" className="mobile-continuity" disabled={!canPropose || proposing} onClick={onPropose}><CheckIcon />{canPropose ? proposing ? t("submitting") : t("submitReview") : t("noDraftChanges")}</button>
      </div>
      <nav className="mobile-nav" aria-label={t("mobileWorkspace")}>
        <button type="button" className={activeView === "outline" ? "active" : ""} onClick={() => onChange("outline")}><List />{t("outline")}</button>
        <button type="button" className={activeView === "write" ? "active" : ""} onClick={() => onChange("write")}><PenLine />{t("write")}</button>
        <button type="button" className={activeView === "changes" ? "active" : ""} onClick={() => onChange("changes")}><FileClock />{t("changes")}</button>
      </nav>
    </div>
  );
}

function CheckIcon() {
  return <span className="mobile-check">✓</span>;
}
